@for (
  context of claimLineInfoContext?.fg_array;
  track context;
  let indexOfelement = $index
) {
  <div class="ClaimLineInfoReview__FormGroup">
    <simple-card class="ClaimLineInfoReview__SimpleCard">
      <div
        title
        class="ClaimLineInfoReview__Title"
        data-test-id="claimLineInfoReviewTitle"
      >
        @if (claimLineInfoContext.fg_array.length === 1) {
          <h6 class="t-bold">{{ claimInfoConfig.title }}</h6>
        } @else {
          <h6 class="t-bold">
            {{ claimInfoConfig.title }} ({{ indexOfelement + 1 }})
          </h6>
        }
        @if (isEditable) {
          <icon
            name="edit"
            [config]="{ type: 'link' }"
            data-test-id="claimLineInfoReviewIcon"
            (click)="editIconClicked()"
          ></icon>
        }
      </div>
      @if (claimInfoConfig.claimLineInformationContent) {
        <ng-container body>
          @for (
            infoConfig of claimInfoConfig.claimLineInformationContent[0]
              .controls;
            track infoConfig
          ) {
            <model-attribute
              class="ClaimLineInfoReview__ModalAttributes"
              [config]="infoConfig"
              [context]="context"
              direction="row"
            >
            </model-attribute>
          }
        </ng-container>
      }
    </simple-card>
  </div>
}
